import { Injectable } from '@angular/core';

import { Subject, Subscription } from 'rxjs';
import { map, filter } from 'rxjs/operators';

interface Event {
    type: string;
    payload?: any;
}

type EventCallback = (payload: any) => void;

@Injectable({
    providedIn: 'root'
})

export class EventService {
    private handler = new Subject<Event>();
    valor : string = '';
    constructor() { }

    /**
     * Broadcast the event
     * @param type type of event
     * @param payload payload
     */
    broadcast(type: string, payload = {}) {
        // console.log ('eventservice broadcast, type', type, ' payload=', payload);
        this.handler.next({ type, payload });
        if(payload === "horizontal"){
            this.pantalla();
            this.valor = "1";
        }else if(payload === "vertical"){
            this.pantalla();
            this.valor = "2";
        }

    }

    cerrarTabs(){
        var evt : Event = {type: 'cerrar_tabs', payload: 'tabs'};
        this.handler.next(evt);
    }

    cerrarTab(SYS02CON){
        var evt : Event = {type: 'cerrar_tab', payload: SYS02CON};
        this.handler.next(evt);
    }

    recargarLista(SYS02CON: string) {alert("Service")
        this.broadcast('EVENTO_REFRESAR_LISTA_' + SYS02CON, {});
    }

    pantalla(){
        if(this.valor === "1"){
            return "horizontal";
        }else if(this.valor === "2"){
            return "vertical";
        }
    }

    /**
     * Subscribe to event
     * @param type type of event
     * @param callback call back function
     */
    subscribe(type: string, callback: EventCallback): Subscription {
        //console.log ('eventservice subscribe, type', type, ' callback=', callback);
        return this.handler.pipe(
            filter(event => event.type === type)).pipe(
                map(event => event.payload))
            .subscribe(callback);
    }

    unSubscribeAll () {
        this.handler.complete();
    }

    Listar() {
        this.handler.forEach(subs=>{
            console.log (subs.type);
        });
    }


}
